<template>
  <v-skeleton-loader
    :loading="isLoading"
    type="text"
    v-intersect.once="{
      handler: onIntersect,
      options: {
        threshold: [0, 0.5, 1.0]
      }
    }">
    <div class="d-flex flex-row gap-1 align-center yard-spot-presenter" style="min-width: 50px">
      <yard-area-presenter :area="area" :area-id="areaId" :size="size" style="min-width: 50px" />
      -
      <span
        :class="size === 'small' ? 'typography-body-sm-bold' : 'typography-body-md-bold'"
        data-testid="yard-spot-presenter-spot-code">
        {{ spotCode }}
      </span>
    </div>
  </v-skeleton-loader>
</template>

<script>
import { defineComponent, toRefs } from 'vue';

import YardAreaPresenter from './YardAreaPresenter.vue';
import { useYardSpotPresenter } from './useYardSpotPresenter';

export default defineComponent({
  name: 'YardSpotPresenter',
  components: {
    YardAreaPresenter
  },
  props: {
    size: {
      type: String,
      required: false,
      default: 'regular',
      validator(value) {
        return ['regular', 'small'].includes(value);
      }
    },
    spot: {
      type: Object,
      required: false,
      default: null
    },
    spotId: {
      type: String,
      required: false,
      default: null
    },
    area: {
      type: Object,
      required: false,
      default: null
    }
  },
  setup(props) {
    const { spotId, spot } = toRefs(props);

    const { areaId, spotCode, isLoading, refresh } = useYardSpotPresenter({ spotId, spot }, true);

    const onIntersect = () => {
      refresh();
    };

    return {
      areaId,
      spotCode,
      isLoading,
      onIntersect
    };
  }
});
</script>

<style scoped>
:deep(.v-skeleton-loader__text) {
  /** this value makes the loader have the same vertical spacing as the spot code text */
  margin: 6px 0 !important;
}
</style>
